const AnniRelazione = [
    {
        anno: '2022',
        descrizioneFile : '(dati 2020-2021)'
    },
    {
        anno: '2021',
        descrizioneFile : 'COVID-19 e impatto sul sistema dei Servizi Socio-Sanitari regionali nel 2020'
    },
    {
        anno: '2020',
        descrizioneFile : '(dati 2019)'
    },
    {
        anno: '2019',
        descrizioneFile : '(dati 2017-2018)'
    },
    {
        anno: '2018',
        descrizioneFile : '(dati 2016-2017)'
    },
    {
        anno: '2017',
        descrizioneFile : '(dati 2015-2016)'
    },
    {
        anno: '2016',
        descrizioneFile : '(dati 2014-2015)'
    },
    {
        anno: '2015',
        descrizioneFile : '(dati 2013-2014)'
    },
    {
        anno: '2014',
        descrizioneFile : '(dati 2012-2013)'
    },
    {
        anno: '2013',
        descrizioneFile : '(dati 2011-2012)'
    },
];

export default AnniRelazione;